import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Hull',
  items: [
    {
      title: 'Piping and Insulation',
      hasMaker: false,
      hasType: false,
      makers: [],
      standardServices: [
        {
          title: 'Pipe Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Steel Structure',
      hasMaker: false,
      hasType: false,
      makers: [],
      standardServices: [
        {
          title: 'UTM',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Remote Access Technicians (Climbing/Drones etc)',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Steel Work',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Surface Coating',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Riding Teams',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
      ],
      items: [],
    },
    {
      title: 'Tanks',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Cargo Tanks Cleaning',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Engine Room Tanks Cleaning',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Underwater Hull and Appendices',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Hull Cleaning - Inspection/Propeller Polishing',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Overboard Valve Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Underwater Steel Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'IWS for Class purposes',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Stern Tube Repair',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
